import CommercialStagingForm from "./CommercialStagingForm"

const VirtualRenovationForm = () => {
    return (
        <CommercialStagingForm unitPrice={5} form_name="Virtual Renovation" />
    )
}

export default VirtualRenovationForm;